import { Component, OnInit } from '@angular/core';
import { GridBaseCase } from "../../grid/grid.base.case";
import { Router,ActivatedRoute } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { PlatformLocation} from '@angular/common';
@Component({
  selector: 'app-mz-button-link1',
  templateUrl: './mz-button-link1.component.html',
  styleUrls: ['./mz-button-link1.component.scss']
})
export class MzButtonLink1Component extends GridBaseCase{

  constructor(
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private activaRouter:ActivatedRoute,
    private platformlocation:PlatformLocation
  ) { super(); }

  ngOnInit() {
  }
  getAction(url) {
    const that=this;
    
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let _btn={};
    _btn["name"]=name;
    _btn["pagename"]=PageName;
    _btn["temp"]=that.template.name;
    localStorage.setItem("btn",JSON.stringify(_btn));
    // const date = new Date();
    if(url){
      // this.router.navigateByUrl(url);
      if (url.indexOf("http") > 0) {
        if(this.element.elementInfo.title){
          this.com.goWebPage(url,this.element.elementInfo.title);
        }else{

        }
      } else {
        that.com.setHistoryUrl();
        if(url.split('/').length==4 || url.split('/').length==5){
          // that.router.navigateByUrl(url+"/"+that.com.getNowDatetime);
          that.com.Go(url+"/"+that.com.getNowDatetime);
        }else if(url.split('/').length==6){
          if(url.indexOf('&')=="-1"){
            // that.router.navigate([url+'&'+that.com.getNowDatetime]);
            that.com.Go(url+'&'+that.com.getNowDatetime);
          }else{
            // that.router.navigate([url+that.com.getNowDatetime]);
            that.com.Go(url+that.com.getNowDatetime);
          }
        }else{
          // that.router.navigateByUrl(url);
          that.com.Go(url);
        }
      } 
    }else{
      this.msg.Show("暂未开通","middle");
    }
  }
}
